import {ITagMetrics, IAdServer} from "@leap4/entities-discrepancy-common";
import {Link} from "react-router-dom";
import {urlService} from "../../../../routing/urlsService";
import KeyValueContainer from "../../../../shared/KeyValueContainer";
import {Card, Grid, Mui} from "@leap4/frontend";
import React, {useContext, useEffect, useState} from "react";
import {UserViewsContext} from "../../../../../contexts/userViewsContext";
import {extractOverviewMetrics, getMetricChangePercent} from "../../../common/OverviewGeneralInfo/OverviewHelpers";
import {metricEnumKeyMap} from "../../../../../utils/enums";
import {SingleMetricForCard} from "../../../common/OverviewGeneralInfo/SingleMetric";


export interface IDataPointCardProps {
    dataPoint: {_id:string,name:string,totals:ITagMetrics,adServer:IAdServer, compareData: ITagMetrics},
}

export const DataPointCard = ({dataPoint}: IDataPointCardProps): JSX.Element => {
    const {userViews} = useContext(UserViewsContext)
    const [initialAllMetrics] = useState(extractOverviewMetrics(dataPoint.totals))
    const [selectedDatesMetrics, setSelectedMetrics] = useState(extractOverviewMetrics(dataPoint.totals))
    const [compareDataMetrics, setCompareDataMetrics] = useState(extractOverviewMetrics(dataPoint.compareData))
    useEffect(() => {
        const {cardViews} = userViews.activePreset
        const newSelectedMetrics = {}
        cardViews.forEach(view => {
            newSelectedMetrics[view] = initialAllMetrics[view]
        })
        setSelectedMetrics(newSelectedMetrics as any)
        setCompareDataMetrics(extractOverviewMetrics(dataPoint.compareData))
    }, [userViews, dataPoint])

    return <Card
        style={{width:'450px', borderRadius: "16px", boxShadow: 'none'}}
        header={{
        title: dataPoint.name.toUpperCase(),
        subtitle: dataPoint.adServer.name
    }
    }
                 actionsArea={{
                     children:
                         <Link
                               to={`${urlService.dataPointOverview(dataPoint._id.toString(), true)}`}><Grid
                             alignContent="space-between" alignItems="center" container>

                             <Grid item xs={12}>

                                 <h2 style={{fontStyle: "oblique"}}>TOTALS</h2>
                                 {Object.keys(selectedDatesMetrics).map(key =>
                                 {
                                     let compareVal
                                     if(!compareDataMetrics) compareVal = null
                                     else compareVal = compareDataMetrics[key]
                                     return(
                                      <KeyValueContainer
                                         key={key}
                                         title={metricEnumKeyMap[key].label.toUpperCase()}
                                         value={
                                             <SingleMetricForCard
                                                 metricValue={selectedDatesMetrics[key] as number} metricEnum={metricEnumKeyMap[key].label}
                                                 metricChange={getMetricChangePercent(selectedDatesMetrics[key], compareVal)}
                                             />
                                         }
                                     />
                                 )
                                 })
                                 }
                             </Grid>
                         </Grid>
                         </Link>
                 }
                 }
    />
}